import { render, staticRenderFns } from "./batch-management-main.vue?vue&type=template&id=dcffe134&scoped=true&"
import script from "./batch-management-main.vue?vue&type=script&lang=js&"
export * from "./batch-management-main.vue?vue&type=script&lang=js&"
import style0 from "./batch-management-main.vue?vue&type=style&index=0&id=dcffe134&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcffe134",
  null
  
)

export default component.exports